export const REDUCER_NAME = 'three-shape'



// WEBPACK FOOTER //
// ./src/modules/threeshape/state/const.js